import React, { useState, useEffect } from 'react';
import { FaTimes, FaCheck } from 'react-icons/fa';
import { getImoveis, updateImovel } from '../services/api';
import './EditarDestaquesModal.css';

const EditarDestaquesModal = ({ isOpen, onClose, onSave }) => {
  const [imoveis, setImoveis] = useState([]);
  const [imoveisDestaque, setImoveisDestaque] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pesquisa, setPesquisa] = useState('');

  useEffect(() => {
    if (isOpen) {
      loadImoveis();
    }
  }, [isOpen]);

  const loadImoveis = async () => {
    try {
      setLoading(true);
      const response = await getImoveis({ disponivel: 'true' });
      const imoveisData = response.data;
      setImoveis(imoveisData);
      setImoveisDestaque(imoveisData.filter(i => i.destaque).map(i => i.id));
    } catch (error) {
      console.error('Erro ao carregar imóveis:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleDestaque = (imovelId) => {
    setImoveisDestaque(prev => {
      if (prev.includes(imovelId)) {
        return prev.filter(id => id !== imovelId);
      } else {
        return [...prev, imovelId];
      }
    });
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      // Atualizar todos os imóveis: remover destaque dos que não estão na lista
      const promises = imoveis.map(async (imovel) => {
        const deveEstarDestaque = imoveisDestaque.includes(imovel.id);
        if (imovel.destaque !== deveEstarDestaque) {
          await updateImovel(imovel.id, { destaque: deveEstarDestaque });
        }
      });
      await Promise.all(promises);
      onSave();
      onClose();
    } catch (error) {
      console.error('Erro ao salvar destaques:', error);
      alert('Erro ao salvar destaques');
    } finally {
      setLoading(false);
    }
  };

  const imoveisFiltrados = imoveis.filter(imovel => {
    if (!pesquisa) return true;
    const pesquisaLower = pesquisa.toLowerCase();
    return (
      imovel.codigo?.toLowerCase().includes(pesquisaLower) ||
      imovel.tipo?.toLowerCase().includes(pesquisaLower) ||
      imovel.bairro?.toLowerCase().includes(pesquisaLower) ||
      imovel.cidade?.toLowerCase().includes(pesquisaLower)
    );
  });

  if (!isOpen) return null;

  return (
    <div className="editar-destaques-modal-overlay" onClick={onClose}>
      <div className="editar-destaques-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Editar Oportunidade de Hoje</h2>
          <button className="btn-close" onClick={onClose}><FaTimes /></button>
        </div>

        <div className="modal-body">
          <div className="search-box">
            <input
              type="text"
              placeholder="Pesquisar imóveis por código, tipo, bairro ou cidade..."
              value={pesquisa}
              onChange={(e) => setPesquisa(e.target.value)}
            />
          </div>

          {loading ? (
            <div className="loading">Carregando imóveis...</div>
          ) : (
            <div className="imoveis-list">
              {imoveisFiltrados.length === 0 ? (
                <p>Nenhum imóvel encontrado</p>
              ) : (
                imoveisFiltrados.map(imovel => (
                  <div 
                    key={imovel.id} 
                    className={`imovel-item ${imoveisDestaque.includes(imovel.id) ? 'destaque' : ''}`}
                    onClick={() => toggleDestaque(imovel.id)}
                  >
                    <div className="imovel-checkbox">
                      {imoveisDestaque.includes(imovel.id) && <FaCheck />}
                    </div>
                    <div className="imovel-info">
                      <strong>{imovel.codigo}</strong> - {imovel.tipo}
                      <br />
                      <small>{imovel.bairro}, {imovel.cidade}</small>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button type="button" className="btn-cancel" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn-save" onClick={handleSave} disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditarDestaquesModal;

